const slider = document.querySelector('[js-partner]')

if (slider) {
  const wrap = slider.querySelector('[js-partner-wrap]')
  const items = slider.querySelectorAll('[js-partner-slide]')
  const size = items.length
  let wrapWidth = size * 180
  wrap.style.width = `${wrapWidth}px`

  // CLONE
  if (wrapWidth < slider.offsetWidth) {
    const cloneChildLength = Math.round(slider.offsetWidth / wrapWidth)
    for (let i = 0; i < cloneChildLength - 1; i++) {
      for( const item of items ) {
        const itemClone = item.cloneNode(true)
        wrap.appendChild(itemClone)
      }
    }

    wrapWidth = wrapWidth * cloneChildLength
    wrap.style.width = `${wrapWidth}px`
    wrap.style.animationDuration = `${size * (cloneChildLength - 1) * 4}s`
  }
  
  const wrapClone = wrap.cloneNode(true);
  slider.appendChild(wrapClone)
  slider.classList.add('is-animated')
}